import { render, staticRenderFns } from "./lbl.vue?vue&type=template&id=245999a6&"
import script from "./lbl.vue?vue&type=script&lang=js&"
export * from "./lbl.vue?vue&type=script&lang=js&"
import style0 from "./lbl.vue?vue&type=style&index=0&id=245999a6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports